module.exports = __webpack_public_path__ + "static/media/Caminho49.9bd0d281.svg";